export default __webpack_public_path__ + "static/media/action-arrow-double-left_darkGray2.78dda350.svg";